<template>
  <div class="row bg-white shadow py-5 px-3 mb-4">
    <div class="col-11">
      <div class="row">
        <div class="col-2">
          <b>Rut</b>
        </div>
        <div class="col-9">
          <div class="row">
            <div class="col-4">
              <b>Nombre/Razón Social</b>
            </div>
            <div class="col-5">
              <b>Giro</b>
            </div>
            <div class="col-3">
              <b>Dirección</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1 text-center">
      <b>...</b>
    </div>
  </div>
</template>

<script>

export default {};

</script>
